import { render, staticRenderFns } from "./Vital.vue?vue&type=template&id=5a6ec044&scoped=true"
import script from "./Vital.vue?vue&type=script&lang=js"
export * from "./Vital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6ec044",
  null
  
)

export default component.exports